export default {
  formatListInQueryStringFormat(arr, namesParam) {
    let arrString = "";

    for (let [i, el] of arr.entries()) {
      if (i === 0) {
        arrString = `${el}`;
      } else {
        arrString = `${arrString}&${namesParam}=${el}`;
      }
    }
    return arrString;
  },
  isSelected(checked, id, name, arr) {
    let listCopy = arr;

    if (listCopy.length > 0) {
      if (listCopy.includes(id)) {
        if (!checked) {
          listCopy.splice(listCopy.indexOf(id), 1);
        }
      } else {
        listCopy.push(id);
      }
    } else {
      listCopy.push(id);
    }

    return listCopy;
  },
  formatTime(dateTime) {
    let dt = new Date(dateTime);

    dt.setHours(dt.getHours() - 3);

    return dt.toLocaleTimeString();
  },
  formatTimePlus(dateTime) {
    let dt = new Date(dateTime);
    let ft = dt.Date("DD-MM-YYYY");
    ft.setHours(dt.getHours() + 3);

    return ft.toLocaleTimeString();
  },
  formatDateTime(dateTime) {
    let dt = new Date(dateTime);

    dt.setHours(dt.getHours() - 3);

    return dt.toLocaleString();
  },
};
